module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pages/pages.component.scss
// module id = ./src/app/pages/pages/pages.component.scss
// module chunks = main